import { Box, Text } from "@chakra-ui/react";
import moment from "moment";

const ChatBox = ({
  isAuthor,
  message,
}: {
  isAuthor: boolean;
  message: any;
}) => {
  return (
    <Box
      maxW="75%"
      w="fit-content"
      m={isAuthor ? "0px 0px 16px auto" : "0px auto 16px 0px"}
    >
      <Box
        bg={isAuthor ? "#287EFF" : "#F0F0F0"}
        color={isAuthor ? "white" : "secondary"}
        borderRadius={isAuthor ? "9px 9px 0px 9px" : "9px 9px 9px 0px"}
        fontSize="14px"
        pr="17px"
        py="12px"
        pl="12px"
        mb="4px"
      >
        <Text color={isAuthor ? "white" : "secondary"}>{message.body}</Text>
      </Box>
      <Text w="100%" textAlign={isAuthor ? "right" : "left"} fontSize="13px">
        {moment(message.dateCreated).fromNow()}
      </Text>
    </Box>
  );
};

export default ChatBox;
